import { render, staticRenderFns } from "./approvalProcess.vue?vue&type=template&id=7017148d&scoped=true"
import script from "./approvalProcess.vue?vue&type=script&lang=js"
export * from "./approvalProcess.vue?vue&type=script&lang=js"
import style0 from "./approvalProcess.vue?vue&type=style&index=0&id=7017148d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7017148d",
  null
  
)

export default component.exports